import { SECTION_BACKGROUNDS, SectionBackground } from '../types/section-background.type';
import { SurfaceMode } from '../types/surface-mode.type';

/** Keep in sync with `section/_section-backgrounds.scss`. */
export const SECTION_SURFACE_MODE: Record<SectionBackground, SurfaceMode | undefined> = {
    default: undefined,
    subtle: 'light',
    inverse: 'dark',
    brand: 'dark',
};

const LEGACY_SECTION_BACKGROUNDS: Readonly<Record<string, SectionBackground>> = {
    white: 'default',
    alternative: 'subtle',
    form: 'subtle',
};

export function normalizeSectionBackground(value?: string | null): SectionBackground | undefined {
    const background = value || 'default';

    return (SECTION_BACKGROUNDS as readonly string[]).includes(background)
        ? (background as SectionBackground)
        : LEGACY_SECTION_BACKGROUNDS[background];
}
